import { render, staticRenderFns } from "./DataLine.vue?vue&type=template&id=4f531b8e&scoped=true&"
import script from "./DataLine.vue?vue&type=script&lang=js&"
export * from "./DataLine.vue?vue&type=script&lang=js&"
import style0 from "./DataLine.vue?vue&type=style&index=0&id=4f531b8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f531b8e",
  null
  
)

export default component.exports